import React from "react";
import TableWithCustomSearch from "../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";

const RemainingSessionTable = () => {
  let {
    table: { data = [], colHeaders = [], columns, rawDataLink, links }
  } = useSelector((state) => state.sessions);

  const addTooltip = (header, formattedValue) =>
    header === "Sales Package" && formattedValue.length > 32 ? (
      <span data-tip={formattedValue}>{formattedValue.substring(0, 32) + "..."}</span>
    ) : (
      formattedValue
    );

  const rebuildTooltip = () => {
    setTimeout(() => {
      ReactTooltip.rebuild();
    }, 0);
  };

  return data.length ? (
    <>
      <ReactTooltip effect="solid" />
      <TableWithCustomSearch
        data={data}
        links={links}
        colHeaders={colHeaders}
        columns={columns}
        rawDataLink={rawDataLink}
        tableWrapperId="remainingSessionTable"
        fileName="remaining-sessions"
        onPageChange={rebuildTooltip}
        onFilteredItemsChange={rebuildTooltip}
        dateConversion={false}
        customFn={(header, formattedValue) => addTooltip(header, formattedValue)}
      />
    </>
  ) : null;
};

export default RemainingSessionTable;
